import { ApiUrlEnum } from '../enum';
import { get } from './api';

export default {
  getJournal: (params: string) => get(`${ApiUrlEnum.JOURNAL}${params}`),
  getJournalMethods: (id: string, params: string) =>
    get(`${ApiUrlEnum.JOURNAL}/${id}${ApiUrlEnum.JOURNAL_METHODS}${params}`),
};
